import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    forgotPassword,
    login,
    returnToLogin,
    sendVerificationCode,
    updateEmail,
    verificationCodeReceived
} from './loginActions';
import {
    getEmail,
    getLoginView
} from './loginViewState';
import {
    getIsLoginLoading,
    getIsVerificationLoading,
    getLoginError,
    getLoginErrorMessage,
    getSendVerificationCodeErrorMessage
} from '../UserData/userDataEntity';
import Form from './LoginForm/LoginForm';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import ConfirmVerificationCodeReceived from './ConfirmVerificationCodeReceived/ConfirmVerificationCodeReceived';
import { historyShape } from '../../utils/propTypes';
import { toastIfError } from '../../utils/toast';
import { getWasAccountCreatedSuccessfully } from '../Signup/signupEntity';

import './Login.scss';

export class Login extends Component {
    static propTypes = {
        email: PropTypes.string,
        error: PropTypes.shape({
            message: PropTypes.string.isRequired
        }),
        errorMessage: PropTypes.string,
        history: historyShape,
        isLoginLoading: PropTypes.bool,
        isVerificationLoading: PropTypes.bool,
        loginView: PropTypes.string,
        onForgotPassword: PropTypes.func,
        onReturnToLogin: PropTypes.func,
        onLogin: PropTypes.func,
        onSendVerificationCode: PropTypes.func,
        onUpdateEmail: PropTypes.func,
        onVerificationCodeReceived: PropTypes.func,
        sendVerificationCodeErrorMessage: PropTypes.string,
        verificationCode: PropTypes.string,
        wasAccountCreatedSuccessfully: PropTypes.bool
    };

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'errorMessage');
        toastIfError(prevProps, this.props, 'sendVerificationCodeErrorMessage');
    }

    renderView() {
        switch (this.props.loginView) {
            case 'forgotPassword':
                return (
                    <ForgotPassword
                        email={this.props.email}
                        isLoading={this.props.isVerificationLoading}
                        onReturnToLogin={this.props.onReturnToLogin}
                        onUpdateEmail={this.props.onUpdateEmail}
                        onSendVerificationCode={this.props.onSendVerificationCode}
                    />
                );

            case 'confirmVerificationCodeReceived':
                return (
                    <ConfirmVerificationCodeReceived
                        email={this.props.email}
                        onReturnToLogin={this.props.onReturnToLogin}
                        onVerificationCodeReceived={this.props.onVerificationCodeReceived}
                    />
                );

            default:
                return (
                    <Form
                        email={this.props.email}
                        isLoading={this.props.isLoginLoading}
                        onLogin={this.props.onLogin(this.props.history)}
                        onUpdateEmail={this.props.onUpdateEmail}
                        onForgotPassword={this.props.onForgotPassword}
                        wasAccountCreatedSuccessfully={this.props.wasAccountCreatedSuccessfully}
                    />
                );
        }
    }

    render() {

        return (
            <div className="emvio-login">
                <div className="login-container">
                    <div className="logo" onClick={this.props.onReturnToLogin} />
                    {this.renderView()}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        email: getEmail(state),
        error: getLoginError(state),
        errorMessage: getLoginErrorMessage(state),
        isLoginLoading: getIsLoginLoading(state),
        isVerificationLoading: getIsVerificationLoading(state),
        loginView: getLoginView(state),
        sendVerificationCodeErrorMessage: getSendVerificationCodeErrorMessage(state),
        wasAccountCreatedSuccessfully: getWasAccountCreatedSuccessfully(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onForgotPassword: (e) => {
            e.preventDefault();
            dispatch(forgotPassword());
        },
        onLogin: (history) => (userName, password) => (e) => {
            e.preventDefault();
            login(userName, password, dispatch, history);
        },
        onReturnToLogin: (e) => {
            e.preventDefault();
            dispatch(returnToLogin());
        },
        onSendVerificationCode: (email) =>
            (e) => {
                e.preventDefault();
                sendVerificationCode(email, dispatch);
            },
        onUpdateEmail: (e) => dispatch(updateEmail(e.target.value)),
        onVerificationCodeReceived: () => dispatch(verificationCodeReceived())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
